import { texts } from '../constants/texts';
import { generateAddress } from './generateAddress';

export const getEntitiesWithAddress = (flats = [], entityName) =>
  flats.reduce((acc, flat) => {
    const augmentedData = flat[entityName].map((item) => {
      const address = generateAddress(flat, flat.address);
      const addressHouse = generateAddress(flat);

      item.address = address;
      item.addressHouse = addressHouse;
      item.key = `${item.id}-${address}`;
      item.streetName = flat.streetName;
      item.building = flat.building;
      item.flat = flat.flat;
      item.addressId = flat.addressId;
      item.houseId = flat.houseId;

      if (flat.corpus) {
        item.corpus = flat.corpus;
      }

      if (item.isOwner !== undefined) {
        item.mark = item.isOwner ? texts.owner : texts.tenant;
      }

      return item;
    });

    return acc.concat(augmentedData);
  }, []);
